export default "/images/vendor/pannellum-react/es/pannellum/css/compass.svg?0f193cd39061ea43cc46b2c0767ade10";